// FTR F19 — file drop zone

import {useState} from 'react'
import {Icon} from '@ui/lib/primitive/Icon'
import {S} from './styles'

export function DropArea({onDrop, onFileSelect, fileInputRef}: {
	onDrop: (e: React.DragEvent) => void
	onFileSelect: (e: React.ChangeEvent<HTMLInputElement>) => void
	fileInputRef: React.RefObject<HTMLInputElement | null>
}) {
	const [isDragging, setIsDragging] = useState(false)
	return (
		<div
			style={{...S.dropZone, ...(isDragging ? S.dropZoneActive : {})}}
			onDragOver={e => { e.preventDefault(); setIsDragging(true) }}
			onDragLeave={e => { e.preventDefault(); setIsDragging(false) }}
			onDrop={e => { setIsDragging(false); onDrop(e) }}
			onClick={() => fileInputRef.current?.click()}
		>
			<Icon icon="tabler:file-spreadsheet" size={48} style={{color: '#aaa', marginBottom: 8}} />
			<p style={S.dropText}>Dra och släpp Excel-fil här</p>
			<p style={S.dropHint}>eller klicka för att välja fil</p>
			<input ref={fileInputRef} type="file" accept=".xlsx,.xls" onChange={onFileSelect} style={{display: 'none'}} />
		</div>
	)
}
